import { EChartsOption, graphic } from "echarts";

export const capacityChartOption = (
  labels: string[],
  capacityWideBodyValues: string[],
  capacityFreighterValues: string[],
  capacityNarrowbodyValues: string[],
  autoWidth?: boolean
): EChartsOption => ({
    "xAxis": {
      "type": "category",
      "data": labels,
      "axisLabel": {
        "color": "#979797",
      },
      "axisLine": {
        "show": false,
      },
      "axisTick": {
        "show": false,
      },
      "boundaryGap": true,
    },
    "tooltip": {
      "trigger": "axis",
      "axisPointer": {
        "type": "line",
      },
      "formatter": (items) => {
        const wideBody = items.find((item) => item.seriesName === "Wide Body"),
         freighter = items.find((item) => item.seriesName === "Freighter"),
         narrowBody = items.find(
          (item) => item.seriesName === "Narrow Body"
        );
        let result = `<div><div style='text-align:center; font-weight:600'>${items?.[0]?.axisValueLabel}</div>`;

        if (wideBody?.data) {
          const wideBodyData = parseInt(wideBody?.data)?.toFixed(1);
          result += `
            <div>
              <span style="color:#8D3E7C">Widebody -</span>
              <span>${wideBodyData}T</span>
            </div>`;
        }

        if (freighter?.data) {
          const freighterData = parseInt(freighter.data)?.toFixed(1);
          result += `
            <div>
              <span style="color:#7CA4D0">Freighter -</span>
              <span>${freighterData}T</span>
            </div>`;
        }

        if (narrowBody?.data) {
          const narrowBodyData = parseInt(narrowBody?.data)?.toFixed(1);

          result += `
            <div>
              <span style="color:#F45814">Narrowbody -</span>
              <span>${narrowBodyData}T</span>
            </div>`;
        }

        result += "</div>";

        return result;
      },
    },
    "grid": {
      "left": "2%",
      "right": "5%",
      "bottom": "5%",
      "top": "2%",
      "containLabel": true,
    },
    "yAxis": {
      "type": "value",
      "axisLabel": {
        "show": true,
        "color": "#979797",
        "formatter": (item) => `${item}T`,
      },
      "splitLine": {
        "show": true,
        "lineStyle": {
          "color": "#F2F4F7",
        },
      },
    },

    "series": [
      {
        "data": capacityWideBodyValues,
        "type": "bar",
        "name": "Wide Body",
        "stack": "one",
        "label": {
          "show": false,
        },
        "barWidth": autoWidth ? "auto" : "60px",

        "itemStyle": {
          "color": "#8D3E7C",
        },
      },

      {
        "data": capacityNarrowbodyValues,
        "type": "bar",
        "name": "Narrow Body",
        "label": {
          "show": false,
        },
        "stack": "one",
        "barWidth": autoWidth ? "auto" : "60px",

        "itemStyle": {
          "color": " #F45814",
        },
      },
      {
        "data": capacityFreighterValues,
        "type": "bar",
        "stack": "one",
        "name": "Freighter",
        "label": {
          "show": false,
        },
        "barWidth": autoWidth ? "auto" : "60px",

        "itemStyle": {
          "color": "#7CA4D0",
          "borderRadius": [5, 5, 0, 0],
        },
      },
    ],
  } as EChartsOption);

export const rateChartOption = (
  labels: string[],
  avgRate: string[],
  minRate: string[]
): EChartsOption => ({
    "xAxis": {
      "type": "category",
      "data": labels,
      "axisLabel": {
        "color": "#979797",
      },
      "axisLine": {
        "show": false,
      },
      "axisTick": {
        "show": false,
      },
      "boundaryGap": true,
    },
    "tooltip": {
      "trigger": "axis",
      "axisPointer": {
        "type": "line",
      },
    },
    "grid": {
      "left": "2%",
      "right": "2%",
      "bottom": "5%",
      "top": "2%",
      "containLabel": true,
    },
    "yAxis": {
      "type": "value",
      "axisLabel": {
        "show": true,
        "color": "#979797",
      },
      "splitLine": {
        "show": true,
        "lineStyle": {
          "color": "#F2F4F7",
        },
      },
    },
    "series": [
      {
        "data": avgRate,
        "type": "line",
        "showSymbol": false,
        "label": {
          "show": false,
        },
        "itemStyle": {
          "color": "#5EA8D8",
        },
        "areaStyle": {
          "color": "rgb(94, 168, 216, 0.5)",
        },
      },
      {
        "data": minRate,
        "type": "line",
        "showSymbol": false,
        "label": {
          "show": false,
        },
        "itemStyle": {
          "color": "#C261F9",
        },
        "areaStyle": {
          "color": "rgb(194, 97, 249, 0.5)",
        },
      },
    ],
  });

export const topTradeLanesChartOption = (
  labels: string[],
  markPoints
): EChartsOption => ({
    "grid": {
      "left": "2%",
      "right": "2%",
      "bottom": "5%",
      "top": "5%",
      "containLabel": true,
    },
    "xAxis": {
      "type": "value",
      "splitLine": {
        "show": false,
      },
      "axisLine": {
        "show": false,
      },
      "axisLabel": {
        "color": "#505050",
        "fontSize": 12,
        "align": "center",
        "fontWeight": 400,
        "formatter": (params) => `${params}%`,
        "margin": 15,
      },
      "axisTick": {
        "show": false,
      },
      "boundaryGap": true,
    },
    "yAxis": {
      "type": "category",
      "data": labels.reverse(),
      "axisLabel": {
        "show": true,
        "color": "#505050",
        "fontSize": 12,
        "fontWeight": 400,
        "margin": 13,
      },
      "axisLine": {
        "show": false,
      },
      "axisTick": {
        "show": false,
      },
      "boundaryGap": true,
    },
    "tooltip": {
      "trigger": "axis",
      "axisPointer": {
        "type": "none",
      },
    },
    "series": [
      {
        "showBackground": true,
        "data": [100, 100, 100, 100, 100],
        "type": "bar",
        "barWidth": "13px",
        "tooltip": {
          "show": false,
        },
        "roundCap": true,
        "backgroundStyle": {
          "borderRadius": [5, 5, 5, 5],
        },
        "itemStyle": {
          "borderRadius": [5, 5, 5, 5],
          "color": new graphic.LinearGradient(0, 0, 1, 0, [
            {
              "offset": 0,
              "color": " #FF5555",
            },
            {
              "offset": 0.5,
              "color": "#FB9E14",
            },
            {
              "offset": 1,
              "color": "#4CC06C",
            },
          ]),
        },
        "markPoint": {
          "data": markPoints,
          "tooltip": {
            "trigger": "item",
            "formatter": (item) => `${item.name} - ${item?.data?.xAxis}%`,
          },
          "symbol": "circle",
          "symbolSize": 24,
        },
      },
    ],
  } as EChartsOption);

export const qualityScoreChartOption = (
  labels: string[],
  routeQualityScoreValues: number[],
  avgQualityScoreValues: number[]
): EChartsOption => ({
    "xAxis": {
      "type": "category",
      "data": labels,
      "axisLabel": {
        "show": true,
        "color": "#979797",
        "interval": 0,
      },
      "axisLine": {
        "show": false,
      },
      "axisTick": {
        "show": false,
      },
      "boundaryGap": true,
    },
    "tooltip": {
      "trigger": "axis",
      "axisPointer": {
        "type": "line",
      },
      "formatter": (items) => {
        const routeQs = items.find(
          (item) => item.seriesName === "Route Quality Score"
        ),
         avgQs = items.find(
          (item) => item.seriesName === "Average Quality Score"
        );
        let result = `<div><div style='text-align:center; font-weight:600'>${items?.[0]?.axisValueLabel}</div>`;

        if (routeQs?.data) {
          const routeQsData = parseInt(routeQs?.data)?.toFixed(1);
          result += `
            <div>
              <span style="color:#5EA8D8">Route Quality -</span>
              <span>${+routeQsData | 0}%</span>
            </div>`;
        }

        if (avgQs?.data) {
          const avgQsData = parseInt(avgQs.data)?.toFixed(1);
          result += `
            <div>
              <span style="color:#f45814">Average Quality -</span>
              <span>${+avgQsData | 0}%</span>
            </div>`;
        }
        result += "</div>";

        return result;
      },
    },
    "grid": {
      "left": "2%",
      "right": "5%",
      "bottom": "5%",
      "top": "2%",
      "containLabel": true,
    },
    "yAxis": {
      "type": "value",
      "axisLabel": {
        "show": true,
        "color": "#979797",
        "formatter": (item) => `${item}`,
      },
      "splitLine": {
        "show": true,
        "lineStyle": {
          "color": "#F2F4F7",
        },
      },
    },

    "series": [
      {
        "data": routeQualityScoreValues,
        "type": "bar",
        "name": "Route Quality Score",
        "label": {
          "show": false,
        },
        "barGap": 0,
        "stack": "one",
        "barMaxWidth": 60,
        "itemStyle": {
          "borderRadius": [5, 5, 0, 0],
          "color": "#5EA8D8",
        },
      },
      {
        "data": avgQualityScoreValues,
        "type": "bar",
        "name": "Average Quality Score",
        "stack": "two",
        "label": {
          "show": false,
        },
        "barMaxWidth": 60,
        "itemStyle": {
          "borderRadius": [5, 5, 0, 0],
          "color": "#f45814",
        },
      },
    ],
  });

export const groupedByWeek = (data: CapacityData[]): GroupedWeekData => {
  const grouped: GroupedWeekData = {};

  data.forEach((item) => {
    const week = item.week;

    if (!grouped[week]) {
      grouped[week] = {};
    }

    if (item["capacity-Widebody"]) {
      grouped[week]["capacity-Widebody"] = item["capacity-Widebody"];
    }

    if (item["capacity-Freighter"]) {
      grouped[week]["capacity-Freighter"] = item["capacity-Freighter"];
    }

    if (item["capacity-Narrowbody"]) {
      grouped[week]["capacity-Narrowbody"] = item["capacity-Narrowbody"];
    }
  });

  return grouped;
};

type CapacityData = {
  week: string;
  "capacity-Widebody"?: string;
  "capacity-Freighter"?: string;
  "capacity-Narrowbody"?: string;
};

type GroupedWeekData = {
  [key: string]: {
    "capacity-Widebody"?: string;
    "capacity-Freighter"?: string;
    "capacity-Narrowbody"?: string;
  };
};
